import React from "react";
import "resources/css/spinner.css"
export default function Spinner() {
  return <div className="spinner"></div>;
}
